<template>
  <div class="parent">
    <center>
      <!-- <div class="container" style="margin-top: 50px"> -->
      <img
        src="https://veis-schoolerp.s3.ap-south-1.amazonaws.com/logo/404.jpg"
        alt=""
      />
      <br />
      <!-- <v-card>
          <v-card-text>
            <h3>404</h3>
            <h4>Page Not Found!!</h4>
            <br />
            
            <v-icon x-large>mdi-magnify-close</v-icon>
            
          </v-card-text>
        </v-card> -->

      <!-- <v-row dense>
        <v-col cols="12" md="5" sm="5">
          <img
            src="https://veis-schoolerp.s3.ap-south-1.amazonaws.com/logo/404.jpg"
            alt=""
            style="width: 90%"
          />
        </v-col>
        <v-col cols="12" md="7" sm="7">
          <h1>
            I have bad news <br />
            for you
          </h1>

          <p>
            The page you are looking <br />for might be removed or is <br />
            temporarily unavailable
          </p>

          <v-btn class="button" @click="back"> Back to Home</v-btn>
        </v-col>
      </v-row> -->
      <v-btn class="button1" @click="back"> Go Home</v-btn>
      <!-- </div> -->
    </center>
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      this.$router.push("/home");
    },
  },
};
</script>

<style scoped>
.button1 {
  background-color: #274078 !important;
  color: white;
  border-radius: 20px;
  border: 2px #274078 !important;
}
.parent {
  background-color: white;
}
</style>